module.exports = {"130127100":"高邑镇","130127101":"大营镇","130127102":"富村镇","130127103":"万城镇","130127201":"中韩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130127.json
// module id = 69
// module chunks = 0